import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vueX/store'
import ElementUI from 'element-ui'
import '@/assets/css/font.css';
import defaultImg from '@/assets/js/defaultImg';
Vue.use(defaultImg);

import clickOutside from '@/assets/js/clickOutside.js'
import keyEvent from '@/assets/js/keyEvent.js'
import longTimeOut from '@/assets/js/long-timeout.js'
Vue.prototype.fireKeyEvent = keyEvent.fireKeyEvent;
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

import Sortable from 'vue-drag-sortable'  //拖动排序组件

import 'element-ui/lib/theme-chalk/index.css'
import common from '@/components/MapEditor/Config/common.js'
// import { fmoney } from '@/components/MapEditor/Config/common.js'
//import echarts from 'echarts'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
import 'echarts-gl' // 3d图表库

import vcolorpicker from 'vcolorpicker'
Vue.use(vcolorpicker)


// 组态3d
import highcharts from 'highcharts'
// import VueHighCharts from 'vue-highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
highcharts3d(highcharts)
Vue.prototype.$highcharts = highcharts

require('events').EventEmitter.defaultMaxListeners = 0

// Vue.prototype.fmoney = fmoney
Vue.use(Vue.directive('clickOutside', clickOutside));
Vue.use(ElementUI)

// 不同平台需要打包不同的样式文件  0：永捷  1：本公司
Vue.prototype.cssType = process.env.CSS_TYPE == undefined ? 0 : process.env.CSS_TYPE;

// 部署环境区分  yonjie：永捷  my：本公司  local:私有化部署
Vue.prototype.env = process.env.ENV_CONFIG == undefined ? 'yonjie' : process.env.ENV_CONFIG;
// console.log(Vue.prototype.env)

Vue.prototype.longTimeOut = longTimeOut;

Vue.component('vue-slider', VueSlider)

Vue.prototype.common = common;

//引入离线仓库
import VueLocalForage from 'vue-localforage'

Vue.use(VueLocalForage)

// 引入mqtt
import mqtt from 'mqtt'
Vue.prototype.$mqtt = mqtt //mqtt
Vue.prototype.$client = {}

//引入axios
import axios from 'axios'
// 引入qs模块，用来序列化post类型的数据
import qs from 'qs'
// 配置axios保存session信息
axios.defaults.withCredentials = true;

// 配置axios 请求的基础路径
// axios.defaults.baseURL = 'http://192.168.3.12/api'  // 测试接口
axios.defaults.baseURL = process.env.BASE_API == undefined ? 'http://iot.yonjie.com/api' : process.env.BASE_API //打包所用服务器 http://iot.yonjie.com http://192.168.3.12

Vue.prototype.baseURL = axios.defaults.baseURL
// 由于axios不支持use，将axios添加到vue原型对象中
Vue.prototype.axios = axios;
Vue.prototype.qs = qs;


/**
 * 判断是否是微信环境
 */
var wx = (function() {
  // return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  return false
})();

/*路由拦截*/
router.beforeEach((to, from, next) => {
  store.state.mask=false
  // console.log(to,from,window.location)
  if(window.location.href.indexOf('screen-3d') != -1){
    next()
  }else if (wx) {
    if (to.fullPath.indexOf('mobile') == -1) {
      next({
        path: '/mobile/dashboard'
      });
    } else {
      next()
    }
  } else {
    let type = Vue.prototype.cssType
    if (localStorage.getItem("loginState")){
      if ((to.fullPath === "/login" || to.fullPath == '/'||to.fullPath == '/TJCloudLogin')&&!localStorage.getItem('indexLoad')) {
        localStorage.removeItem("loginState")
        next({
          path: type == 0 ? '/login' : '/TJCloudLogin'
        });
      } else {
        next();
      }
    } else if(to.fullPath.indexOf('/indexPreview')==-1){
      if (to.fullPath != '/login'&&to.fullPath != '/TJCloudLogin') {
        sessionStorage.setItem('routerNext', to.fullPath)
        next({
          path: type == 0 ? '/login' : '/TJCloudLogin'
        });
      }else{
        next();
      }
    }else if(to.fullPath.indexOf('/indexPreview')!=-1){
      next();
    }
  }
});
//避免路由版本差异引起不必要的bug
import Router from 'vue-router'
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

var _identifier = '0-'; //标识定义  	type => String

// 封装get请求
Vue.prototype.get = function(url, params) {
  // console.log(url)
  var self = this;
  // 老版本v1接口前缀没有 /v1 所以要手动加上
  // v2版本的请求接口调用时添加 如/v2/apiUrl
  if(url.indexOf('/v2')==-1){
    url='/v1'+url
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('Identifier')) {
      var Identifier = localStorage.getItem('Identifier').split('-')[0] + '-' + Number(Number(localStorage.getItem(
        'Identifier').split('-')[1]) + 1)
    } else {
      var Identifier = _identifier + '1'
    }
    localStorage.setItem('Identifier', Identifier)
    var requestId = Number(Identifier.split('-')[0] + Identifier.split('-')[1])
    if(requestId>100000000){
       localStorage.setItem('Identifier', "0-1")
    }
    if (params == undefined) {
      params = {}
    }
    if(store.state.openId){
      params.openId = store.state.openId
    }
    params.requestId = requestId
    // const loading = self.$loading({
    // 	lock: true,
    // 	text: 'Loading',
    // 	spinner: 'el-icon-loading',
    // 	background: 'transparent'
    // });
    if ((url.indexOf('/get') != -1) || (url.indexOf('/query') != -1)) {
      axios.get(url, {
          headers: params.openId?{'isWX': true}:null,
          params: params
        }, {
          withCredentials: true
        })
        .then(res => {
          // || (!res.data.success && res.data.result == 0 && localStorage.getItem('loginState') && !localStorage.getItem('OverdueTips'))
          if ((!res.data.success && res.data.result == 3 && localStorage.getItem('loginState') && !localStorage
              .getItem('OverdueTips'))) {
            localStorage.setItem('OverdueTips', '1')
            localStorage.removeItem('loginState');
            localStorage.removeItem('indexLoad');
            localStorage.setItem('isLook', false);
            if(store.state.client){
              store.state.client.end()
            }
            store.state.isLook = false
            if (wx) return
            let type = Vue.prototype.cssType
            self.$alert(res.data.message, '会话过期', {
              confirmButtonText: '确定',
              callback: action => {
                localStorage.removeItem('OverdueTips');
                self.$router.push({
                  path: type == 0 ? '/login' : '/TJCloudLogin'
                })
              }
            });
          } else {
            if (localStorage.getItem('loginState') && this.$route.path != "/login") {
              resolve(res.data)
            } else {
              resolve(res.data)
            }
          }
          store.state.networkError=false
          // loading.close()
        })
        .catch(err => {
          reject(err)
          if(err=="Error: Network Error"){
            store.state.networkError=true
          }
        })
    } else {
      let arr = sessionStorage.getItem('GetURL');
      arr = arr ? JSON.parse(arr) : [];
      if (!arr.includes(url)) {
        arr.push(url);
        sessionStorage.setItem('GetURL', JSON.stringify(arr))
        axios.get(url, {
            headers: params.openId?{'isWX': true}:null,
            params: params
          }, {
            withCredentials: true,

          })
          .then(res => {
            let arrByBack = JSON.parse(sessionStorage.getItem('GetURL'));
            sessionStorage.setItem('GetURL', JSON.stringify(self.common.remove(arrByBack, url)))
            if (!res.data.success && res.data.result == 3 && localStorage.getItem('loginState') && !localStorage.getItem('OverdueTips')) {
              localStorage.setItem('OverdueTips', '1')
              localStorage.removeItem('loginState');
              localStorage.removeItem('indexLoad');
              localStorage.setItem('isLook', false);
              store.state.isLook = false
              if(store.state.client){
                store.state.client.end()
              }
              let type = Vue.prototype.cssType
              if (wx) return
              self.$alert('请重新登录', '会话过期', {
                confirmButtonText: '确定',
                callback: action => {
                  localStorage.removeItem('OverdueTips');
                  self.$router.push({
                    path: type == 0 ? '/login' : '/TJCloudLogin'
                  })
                }
              });
            } else {
              if (localStorage.getItem('loginState') && this.$route.path != "/login") {
                resolve(res.data)
              } else {
                resolve(res.data)
              }
            }
            store.state.networkError=false
            // loading.close()
          })
          .catch(err => {
            let arrByBack = JSON.parse(sessionStorage.getItem('GetURL'));
            sessionStorage.setItem('GetURL', JSON.stringify(self.common.remove(arrByBack, url)))
            reject(err)
            if(err=="Error: Network Error"){
              console.log("断网啦22")
              store.state.networkError=true
            }
          })
      } else {
        return
        self.$message({
          showClose: true,
          message: '正在提交...请勿重复操作',
          type: 'warning'
        });
      }
    }
  })
};

// 封装微信端get请求
Vue.prototype.wx_get = function(url, params) {
  var self = this;
  // 老版本v1接口前缀没有 /v1 所以要手动加上
  if(url.indexOf('/v2')==-1){
    url='/v1'+url
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('Identifier')) {
      var Identifier = localStorage.getItem('Identifier').split('-')[0] + '-' + Number(Number(localStorage.getItem(
        'Identifier').split('-')[1]) + 1)
    } else {
      var Identifier = _identifier + '1'
    }
    localStorage.setItem('Identifier', Identifier)
    var requestId = Number(Identifier.split('-')[0] + Identifier.split('-')[1])
    if(requestId>100000000){
       localStorage.setItem('Identifier', "0-1")
    }
    if (params == undefined) {
      params = {}
    }
    params.requestId = requestId
    params.openId = store.state.openId

    if ((url.indexOf('/get') != -1) || (url.indexOf('/query') != -1)) {
      axios.get(url, {
          headers: {
            'isWX': true
          },
          params: params
        }, {
          withCredentials: true
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      let arr = sessionStorage.getItem('wxGetURL');
      arr = arr ? JSON.parse(arr) : [];
      if (!arr.includes(url)) {
        arr.push(url);
        sessionStorage.setItem('wxGetURL', JSON.stringify(arr))
        axios.get(url, {
            headers: {
              'isWX': true
            },
            params: params
          }, {
            withCredentials: true
          })
          .then(res => {
            let arrByBack = JSON.parse(sessionStorage.getItem('wxGetURL'));
            sessionStorage.setItem('wxGetURL', JSON.stringify(self.common.remove(arrByBack, url)))
            resolve(res.data)
          })
          .catch(err => {
            let arrByBack = JSON.parse(sessionStorage.getItem('wxGetURL'));
            sessionStorage.setItem('wxGetURL', JSON.stringify(self.common.remove(arrByBack, url)))
            reject(err)
          })
      } else {
        return
        self.$message({
          showClose: true,
          message: '正在提交...请勿重复操作',
          type: 'warning'
        });
      }
    }
  })
};

// 封装微信端post请求
Vue.prototype.wx_post = function(url, params) {
  var self = this;
  // 老版本v1接口前缀没有 /v1 所以要手动加上
  if(url.indexOf('/v2')==-1){
    url='/v1'+url
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('Identifier')) {
      var Identifier = localStorage.getItem('Identifier').split('-')[0] + '-' + Number(Number(localStorage.getItem(
        'Identifier').split('-')[1]) + 1)
    } else {
      var Identifier = _identifier + '1'
    }
    localStorage.setItem('Identifier', Identifier)
    var requestId = Number(Identifier.split('-')[0] + Identifier.split('-')[1])
    if(requestId>100000000){
       localStorage.setItem('Identifier', "0-1")
    }
    if (params == undefined) {
      params = {}
    }
    params.requestId = requestId
    params.openId = store.state.openId
    //console.log(params)
    //需要使用qs.stringify()序列化post类型的数据
    if ((url.indexOf('/Device/setPropertyValue') != -1) || url.indexOf('/VirtualDevice/updateProperty') != -1) {
      axios.post(url, qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'isWX': true
          },
          withCredentials: true
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      let arr = sessionStorage.getItem('wxPostURL');
      arr = arr ? JSON.parse(arr) : [];
      if (!arr.includes(url)) {
        arr.push(url);
        sessionStorage.setItem('wxPostURL', JSON.stringify(arr))
        axios.post(url, qs.stringify(params), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'isWX': true
            },
            withCredentials: true
          })
          .then(res => {
            let arrByBack = JSON.parse(sessionStorage.getItem('wxPostURL'));
            sessionStorage.setItem('wxPostURL', JSON.stringify(self.common.remove(arrByBack, url)))
            resolve(res.data)
          })
          .catch(err => {
            let arrByBack = JSON.parse(sessionStorage.getItem('wxPostURL'));
            sessionStorage.setItem('wxPostURL', JSON.stringify(self.common.remove(arrByBack, url)))
            reject(err)
          })
      } else {
        // console.log(url)
        // self.$message({
        //   showClose: true,
        //   message: '正在提交...请勿重复操作',
        //   type: 'warning'
        // });
      }
    }
  })
};

// 封装get请求 下载后台返回文件
Vue.prototype.getFile = function(url, params) {
  // 老版本v1接口前缀没有 /v1 所以要手动加上
  if(url.indexOf('/v2')==-1){
    url='/v1'+url
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('Identifier')) {
      var Identifier = localStorage.getItem('Identifier').split('-')[0] + '-' + Number(Number(localStorage.getItem(
        'Identifier').split('-')[1]) + 1)
    } else {
      var Identifier = _identifier + '1'
    }
    localStorage.setItem('Identifier', Identifier)
    var requestId = Number(Identifier.split('-')[0] + Identifier.split('-')[1])
    if(requestId>100000000){
       localStorage.setItem('Identifier', "0-1")
    }
    if (params == undefined) {
      params = {}
    }
    params.requestId = requestId
    axios.get(url, {
        params: params
      }, {
        withCredentials: true,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
};

// 封装post请求
Vue.prototype.post = function(url, params) {
  let self = this;
  // 老版本v1接口前缀没有 /v1 所以要手动加上
  if(url.indexOf('/v2')==-1){
    url='/v1'+url
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('Identifier')) {
      var Identifier = localStorage.getItem('Identifier').split('-')[0] + '-' + Number(Number(localStorage.getItem(
        'Identifier').split('-')[1]) + 1)
    } else {
      var Identifier = _identifier + '1'
    }
    localStorage.setItem('Identifier', Identifier)
    var requestId = Number(Identifier.split('-')[0] + Identifier.split('-')[1])
    if(requestId>100000000){
       localStorage.setItem('Identifier', "0-1")
    }
    if (params == undefined) {
      params = {}
    }
    if(store.state.openId){
      params.openId = store.state.openId
    }
    params.requestId = requestId
    //console.log(params)
    //需要使用qs.stringify()序列化post类型的数据
    if ((url.indexOf('/Device/setPropertyValue') != -1) || url.indexOf('/VirtualDevice/updateProperty') != -1) {
      axios.post(url, qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'isWX': params.openId ? true: null
          },
          withCredentials: true
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      let arr = sessionStorage.getItem('PostURL');
      arr = arr ? JSON.parse(arr) : [];
      if (!arr.includes(url)) {
        arr.push(url);
        sessionStorage.setItem('PostURL', JSON.stringify(arr))
        axios.post(url, qs.stringify(params), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'isWX': params.openId ? true: null
            },
            withCredentials: true
          })
          .then(res => {
            let arrByBack = JSON.parse(sessionStorage.getItem('PostURL'));
            sessionStorage.setItem('PostURL', JSON.stringify(self.common.remove(arrByBack, url)))
            resolve(res.data)
          })
          .catch(err => {
            let arrByBack = JSON.parse(sessionStorage.getItem('PostURL'));
            sessionStorage.setItem('PostURL', JSON.stringify(self.common.remove(arrByBack, url)))
            reject(err)
          })
      } else {
        // self.$message({
        //   showClose: true,
        //   message: '正在提交...请勿重复操作',
        //   type: 'warning'
        // });
      }
    }
  })
};

// 封装Form表单头部post请求
Vue.prototype.postForm = function(url, params) {
  let self = this;
  // 老版本v1接口前缀没有 /v1 所以要手动加上
  if(url.indexOf('/v2')==-1){
    url='/v1'+url
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('Identifier')) {
      var Identifier = localStorage.getItem('Identifier').split('-')[0] + '-' + Number(Number(localStorage.getItem(
        'Identifier').split('-')[1]) + 1)
    } else {
      var Identifier = _identifier + '1'
    }
    localStorage.setItem('Identifier', Identifier)
    var requestId = Number(Identifier.split('-')[0] + Identifier.split('-')[1])
    if(requestId>100000000){
       localStorage.setItem('Identifier', "0-1")
    }
    if (params == undefined) {
      params = {}
    }
    params.append('requestId', requestId)
    let arr = sessionStorage.getItem('postFormURL');
    arr = arr ? JSON.parse(arr) : [];
    if (!arr.includes(url)) {
      arr.push(url);
      sessionStorage.setItem('postFormURL', JSON.stringify(arr))
      axios.post(url, params, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true
        })
        .then(res => {
          let arrByBack = JSON.parse(sessionStorage.getItem('postFormURL'));
          sessionStorage.setItem('postFormURL', JSON.stringify(self.common.remove(arrByBack, url)))
          resolve(res.data)
        })
        .catch(err => {
          let arrByBack = JSON.parse(sessionStorage.getItem('postFormURL'));
          sessionStorage.setItem('postFormURL', JSON.stringify(self.common.remove(arrByBack, url)))
          reject(err)
        })
    } else {
      // console.log(url)
      // self.$message({
      //   showClose: true,
      //   message: '正在提交...请勿重复操作',
      //   type: 'warning'
      // });
    }
  })
};

// 封装post请求 不进行json格式转换
Vue.prototype.postNoJson = function(url, params) {
  let self = this;
  // 老版本v1接口前缀没有 /v1 所以要手动加上
  if(url.indexOf('/v2')==-1){
    url='/v1'+url
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem('Identifier')) {
      var Identifier = localStorage.getItem('Identifier').split('-')[0] + '-' + Number(Number(localStorage.getItem(
        'Identifier').split('-')[1]) + 1)
    } else {
      var Identifier = _identifier + '1'
    }
    localStorage.setItem('Identifier', Identifier)
    var requestId = Number(Identifier.split('-')[0] + Identifier.split('-')[1])
    if(requestId>100000000){
       localStorage.setItem('Identifier', "0-1")
    }
    if (params == undefined) {
      params = {}
    }
    params.requestId = requestId;
    // params = JSON.stringify(params)
    let arr = sessionStorage.getItem('postNoJsonURL');
    arr = arr ? JSON.parse(arr) : [];
    if (!arr.includes(url)) {
      arr.push(url);
      sessionStorage.setItem('postNoJsonURL', JSON.stringify(arr))
      axios.post(url, params, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
          withCredentials: true
        })
        .then(res => {
          let arrByBack = JSON.parse(sessionStorage.getItem('postNoJsonURL'));
          sessionStorage.setItem('postNoJsonURL', JSON.stringify(self.common.remove(arrByBack, url)))
          resolve(res.data)
        })
        .catch(err => {
          let arrByBack = JSON.parse(sessionStorage.getItem('postNoJsonURL'));
          sessionStorage.setItem('postNoJsonURL', JSON.stringify(self.common.remove(arrByBack, url)))
          reject(err)
        })
    } else {
      // console.log(url)
      // self.$message({
      //   showClose: true,
      //   message: '正在提交...请勿重复操作',
      //   type: 'warning'
      // });
    }
  })
};

//    import Vconsole from 'vconsole'
//    let vConsole = new Vconsole()
//    Vue.use(vConsole)

//隐藏手机号中间4位
Vue.prototype.hidePhone = function(phone) {
  if (phone == "" || phone == null) {
    return
  }
  return phone.substr(0, 3) + "****" + phone.substr(7);
};

//时间戳转换日期 年-月-日
Vue.prototype.changeDate = function(now) {
  if (now == "" || now == null || typeof now == 'string') {
    return
  }
  now = new Date(Number(now))
  let year = now.getFullYear(); //取得4位数的年份
  let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
  let date = now.getDate(); //返回日期月份中的天数（1到31）
  if (month < 10) {
    month = "0" + month
  }
  if (date < 10) {
    date = "0" + date
  }
  return year + "-" + month + "-" + date;
}

//时间戳转换日期 年-月-日 时：分：秒
Vue.prototype.changeTime = function(now) {
  if (now == "" || now == null || typeof now == 'string') {
    return
  }
  now = new Date(Number(now))
  let year = now.getFullYear(); //取得4位数的年份
  let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
  let date = now.getDate(); //返回日期月份中的天数（1到31）
  let hour = now.getHours(); //返回日期中的小时数（0到23）
  let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
  let second = now.getSeconds(); //返回日期中的秒数（0到59）
  if (month < 10) {
    month = "0" + month
  }
  if (date < 10) {
    date = "0" + date
  }
  if (hour < 10) {
    hour = "0" + hour
  }
  if (minute < 10) {
    minute = "0" + minute
  }
  if (second < 10) {
    second = "0" + second
  }

  let bigScreen = ["/DevopsPreview", '/CompanyConsole/IndexEditShow']
  if (bigScreen.includes(this.$route.path)) {
    return `${month+"-"+date} ${hour + ':' + minute+":"+second}`;
  } else {
    return `${year+"-"+month+"-"+date} ${hour + ':' + minute+":"+second}`;
  }
}

//时间戳转换日期 年-月-日 时：分：秒
Vue.prototype.changeTimeY = function(now) {
  if (now == "" || now == null || typeof now == 'string') {
    return
  }
  now = new Date(Number(now))
  let year = now.getFullYear(); //取得4位数的年份
  let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
  let date = now.getDate(); //返回日期月份中的天数（1到31）
  let hour = now.getHours(); //返回日期中的小时数（0到23）
  let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
  let second = now.getSeconds(); //返回日期中的秒数（0到59）
  if (month < 10) {
    month = "0" + month
  }
  if (date < 10) {
    date = "0" + date
  }
  if (hour < 10) {
    hour = "0" + hour
  }
  if (minute < 10) {
    minute = "0" + minute
  }
  if (second < 10) {
    second = "0" + second
  }

  return `${year+"-"+month+"-"+date} ${hour + ':' + minute+":"+second}`;

}
//base64转码
Vue.prototype.dataURItoBlob = function(dataURI) {
  let byteString = window.atob(dataURI.split(',')[1]);
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  let T = mimeString.split('/')[1];
  let ab = new ArrayBuffer(byteString.length);
  let ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {
    type: mimeString
  });
};

// import Tools from '@/assets/js/tools'
// Vue.use(Tools)
// // 为了解决setItemEvent不立即生效，使用事件派发强制更高
// // Tools.dispatchEventStroage()
// // console.log(Tools)
// Tools()

// 封装修改localStorage的setItem
// Vue.prototype.$myStorage = function (key, data) {
// 	// 创建一个StorageEvent事件
// 	var newStorageEvent = document.createEvent('StorageEvent');
// 	const storage = {
// 		setItem: function (k, val) {
// 			localStorage.setItem(k, val);
// 			// 初始化创建的事件
// 			newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
// 			// 派发对象
// 			window.dispatchEvent(newStorageEvent);
// 		}
// 	}
// 	return storage.setItem(key, data);
// }

// 查看模式定时器
Vue.prototype.lookTime = function(time) {
  if (!localStorage.getItem("loginState") || store.state.isLook) { //未登录不开启定时器
    localStorage.setItem('isLook', false)
    clearInterval(Vue.timeInterval)
    return
  }

  if(time==0) return
  time = Number(time) * 60 * 1000
  // time = 60000 * 60 *1000
  Vue.timeInterval ? clearInterval(Vue.timeInterval) : null
  Vue.timeInterval = setInterval(() => {
    if (!localStorage.getItem("loginState")) { //未登录清除定时器
      clearInterval(Vue.timeInterval)
      return
    }
    let lastClikcTime;
    // localStorage.getItem('lastClickTime') ? lastClikcTime = Number(localStorage.getItem('lastClickTime')) : new Date().getTime();
    if (localStorage.getItem('lastClickTime')) { //获取最后一次点击时间
      lastClikcTime = Number(localStorage.getItem('lastClickTime'))
    } else {
      localStorage.setItem('lastClickTime', new Date().getTime())
    }
    let nowTime = new Date().getTime() //当前时间
    if (nowTime - lastClikcTime > time) {
      localStorage.setItem('isLook', true)
      store.state.isLook = true
      //console.log('clear')		//延迟释放内存，避免多页面查看模式状态不一致
      this.timeInterval = null
      clearInterval(Vue.timeInterval)
      localStorage.removeItem('lastClickTime')
    } else {
      // console.log(nowTime-lastClikcTime,localStorage.getItem('isLook'))
      store.state.isLook = localStorage.getItem('isLook') == 'true' ? true : false //避免多页面查看模式状态不一致
      // store.state.isLook = false
    }
  }, 3000)
}

// 默认展开组织数组
Vue.prototype.expanded = function(data, level) {
  if (!data) {
    return;
  }
  let i = 0;
  for (i; i < data.length; i++) {
    data[i].level = level;
    data[i].key = data[i].roleId + '_' + data[i].id + data[i].type
    if (level < 5) {
      this.$store.state.expandedArr.push(data[i].key)
    }
    this.expanded(data[i].children, level + 1);
  }
  return data;
}

// window.open处理函数
Vue.prototype.windowOpen = function(path, params, childrenPath, title) {
  let routerMyCard = this.$router.resolve({
    path: path
  })

  // 服务器打包需要切割'/dist'
  let reg = new RegExp('/dist')
  routerMyCard.href = routerMyCard.href.replace(reg, "")
  // 子路由
  if (childrenPath) {
    routerMyCard.href = routerMyCard.href + childrenPath
  }
  let obj = {},origin = window.location.origin;
  try {
    // console.log(routerMyCard.href, params,sessionStorage)
    obj = window.open(routerMyCard.href, params);
    let msgobj = {
      emitElectronMsg: routerMyCard.href,
      title:title
    }
    console.log(JSON.stringify(msgobj))
    // obj = window.open(origin+routerMyCard.href, params);
  } catch (err) {
    console.log('报错啦')
    console.warn(err)
  }
  // console.log(obj)
}

//大数处理
Vue.prototype.bigNumberTransform = function(value,length) {
  // intLenght => 整数长度
  // value => 需要处理的数值
  // length => 最后显示的数值
    if(value!=0&&!value){ return value}

    var intLenght,param = {},k = 10000,sizes = ['', '万', '亿', '万亿'],i,f='';
      if(value<0){
        f = '-'
      }
        value = Math.abs(value)

        if(value%1 == 0){
          intLenght = value.toString().length
        }else{
          let arr = value.toString().split('.')
          intLenght = arr[0].length
        }
        if(intLenght <= length){
          value = value.toFixed(length-intLenght);
          if(value%1 == 0){
            value = parseInt(value)
          }
          return f + parseFloat(value)
        }

        if(value*10 < k){
            param.value = value.toFixed(2)
            param.unit=''
        }else{
            i = Math.floor(Math.log(value) / Math.log(k));
            param.value = (value / Math.pow(k, i));
            param.unit = sizes[i];
        }
        if(param.value%1 == 0){
          if(value.toString().length <= length){ return value}
          param.value = parseInt(param.value)
          intLenght = param.value.toString().length
        }else{
          let arr = param.value.toString().split('.')
          intLenght = arr[0].length
        }
        if(param.unit=='万亿'){
          param.value = param.value.toFixed(length-intLenght - 2)
        }else if(param.unit){
          param.value = param.value.toFixed(length-intLenght - 1)
        }
        if(param.value%1 == 0){
          param.value = parseInt(param.value)
        }
      return f + parseFloat(param.value);
}

Vue.prototype.fmoney = (v)=>{
    if(v %1 != 0){
      v = v.toFixed(2)
    }
    var res=v.toString().replace(/\d+/, function(n){ // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
         return $1+",";
      });
    })
    return res;
  }

//引入克隆函数
import clone from './assets/js/deepClone.js'
Vue.prototype.clone = clone

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  components: { Sortable },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js